import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Row, FieldInput, FieldDatePicker, FieldDropdown, Group } from '@/components/form'
import { fontWeights } from '@/styles'
import DepositAccountField from './deposit-account'

const SubHeader = styled.p`
  font-size: 15px;
  font-weight: ${fontWeights.medium};
  padding-bottom: 20px;
  margin: 0px;
  text-align: left;
  width: 100%;
`

const OneTimeFields = ({ accountData }) => {
  const { t } = useTranslation()
  const isRequired = accountData?.financial_info !== undefined

  return (
    <>
      <DepositAccountField isRequired={isRequired} accountData={accountData} />
      <SubHeader>{t('l.payments.view.rent_info.title', 'Rent Info')}</SubHeader>
      <Row>
        <Group>
          <FieldDropdown
            id="description"
            name="description"
            placeholder={
              '1. ' +
              t('l.payments.view.request_payment_modal.description_label', 'What is this for?')
            }
            autoFocus
            options={[
              {
                value: 'Rent Payment',
                label: t(
                  'l.payments.view.request_payment_modal.description_rent_payment',
                  'Rent Payment'
                )
              },
              {
                value: 'Deposit',
                label: t('l.payments.view.request_payment_modal.description_deposit', 'Deposit')
              }
            ]}
            required
          />
        </Group>
      </Row>
      <Row>
        <Group>
          <FieldInput
            id="requested_amount"
            name="requested_amount"
            prefix="$"
            autoComplete="off"
            placeholder={
              '2. ' +
              t(
                'l.payments.view.request_payment_modal.requested_amount_label',
                'How much do you want to charge?'
              )
            }
            required
          />
        </Group>
      </Row>
      <Row>
        <Group>
          <FieldDatePicker
            id="due_date"
            name="due_date"
            placeholder={
              '3. ' +
              t('l.payments.view.request_payment_modal.due_date_label', 'When is this payment due?')
            }
            disablePast
            required
          />
        </Group>
      </Row>
    </>
  )
}

export default OneTimeFields
